import { IconWrapper } from '../runtime';
export default IconWrapper('contact-format', false, function (h, props) {
  return h("svg", {
    "attrs": {
      "width": props.size,
      "height": props.size,
      "viewBox": "0 0 24 24",
      "fill": "none"
    }
  }, [h("g", [h("g", {
    "attrs": {
      "filter": 'url(#' + props.id + 'c4767a04' + ')'
    }
  }, [h("path", {
    "attrs": {
      "d": "M0 3.75C0 1.67893 1.67893 0 3.75 0H20.25C22.3211 0 24 1.67893 24 3.75V20.25C24 22.3211 22.3211 24 20.25 24H3.75C1.67893 24 0 22.3211 0 20.25V3.75Z",
      "fill": 'url(#' + props.id + '2728aa67' + ')'
    }
  })]), h("path", {
    "attrs": {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      "d": "M6.80469 13.4126V18.0327C6.80469 18.6091 7.27193 19.0764 7.8483 19.0764H11V19.0799H13V19.0764H16.1508C16.7272 19.0764 17.1944 18.6091 17.1944 18.0327V13.4148L12.3866 18.6611C12.1798 18.8868 11.8241 18.8868 11.6173 18.6612L6.80469 13.4126Z",
      "fill": "white",
      "fill-opacity": "0.5"
    }
  }), h("path", {
    "attrs": {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      "d": "M18.9772 10.1753C19.4312 10.1753 19.6686 10.715 19.3619 11.0497L12.3866 18.6611C12.1798 18.8868 11.8241 18.8868 11.6173 18.6612L4.63823 11.0498C4.33137 10.7151 4.56878 10.1753 5.02283 10.1753H18.9772Z",
      "fill": "white",
      "fill-opacity": "0.7"
    }
  }), h("path", {
    "attrs": {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      "d": "M11.9988 10.1753H5.02283C4.56878 10.1753 4.33137 10.7151 4.63823 11.0498L11.6173 18.6612C11.7199 18.7732 11.8592 18.8296 11.9988 18.8304V10.1753Z",
      "fill": "white",
      "fill-opacity": "0.7"
    }
  }), h("path", {
    "attrs": {
      "d": "M14.9668 6.4684C14.9668 8.10785 13.6377 9.43689 11.9983 9.43689C10.3588 9.43689 9.02979 8.10785 9.02979 6.4684C9.02979 4.82895 10.3588 3.49991 11.9983 3.49991C13.6377 3.49991 14.9668 4.82895 14.9668 6.4684Z",
      "fill": "white"
    }
  })]), h("defs", [h("filter", {
    "attrs": {
      "id": props.id + 'c4767a04',
      "x": "0",
      "y": "0",
      "width": "24",
      "height": "24",
      "filterUnits": "userSpaceOnUse",
      "color-interpolation-filters": "sRGB"
    }
  }, [h("feFlood", {
    "attrs": {
      "flood-opacity": "0",
      "result": "BackgroundImageFix"
    }
  }), h("feBlend", {
    "attrs": {
      "mode": "normal",
      "in": "SourceGraphic",
      "in2": "BackgroundImageFix",
      "result": "shape"
    }
  }), h("feColorMatrix", {
    "attrs": {
      "in": "SourceAlpha",
      "type": "matrix",
      "values": "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
      "result": "hardAlpha"
    }
  }), h("feOffset", {
    "attrs": {
      "dy": "-0.75"
    }
  }), h("feComposite", {
    "attrs": {
      "in2": "hardAlpha",
      "operator": "arithmetic",
      "k2": "-1",
      "k3": "1"
    }
  }), h("feColorMatrix", {
    "attrs": {
      "type": "matrix",
      "values": "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.06 0"
    }
  }), h("feBlend", {
    "attrs": {
      "mode": "normal",
      "in2": "shape",
      "result": "effect1_innerShadow_913_635"
    }
  })]), h("linearGradient", {
    "attrs": {
      "id": props.id + '2728aa67',
      "x1": "34.0978",
      "y1": "12.1863",
      "x2": "11.7639",
      "y2": "-9.30073",
      "gradientUnits": "userSpaceOnUse"
    }
  }, [h("stop", {
    "attrs": {
      "stop-color": "#EA4702"
    }
  }), h("stop", {
    "attrs": {
      "offset": "1",
      "stop-color": "#F4911D"
    }
  })])])]);
});